import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { AppContext } from '@src/context/store';
import { InnerPrivacyToolsComponent } from './privacy-tools.component';
import { isAppEnabled, isADISite, getKBLinks } from '@src/context/selectors/ui-settings';
import { NavigationContext } from '@src/context/navigation-store/navigation-store';
import { getEditorUrlForDoNotSellApp, getIsDoNotSellAppInstalled } from '@src/context/selectors/app-settings';

export interface Props extends InjectedTranslateProps {}

export const PrivacyTools = (props: Props) => {
  const state = React.useContext(AppContext);
  const { navigateToRoute } = React.useContext(NavigationContext);
  const { t } = props;

  return (
    <InnerPrivacyToolsComponent
      t={t}
      editorUrlForDoNotSell={getEditorUrlForDoNotSellApp(state)}
      isSellDataInstalled={getIsDoNotSellAppInstalled(state)}
      appInstalled={state.isAppInstalled}
      appEnabled={isAppEnabled(state)}
      isADISite={isADISite(state)}
      navigateToRoute={navigateToRoute}
      learnMoreKBLink={getKBLinks(state).PrivacyToolsDescriptionLearnMore}
    />
  );
};

export const PrivacyToolsComponent = translate()(PrivacyTools);
